import { gql } from '@apollo/client'
import {
  AiIcon,
  BookIcon,
  CheckIcon,
  CloseIcon,
  FileSearchIcon,
  Heading,
  IconComponent,
  IconList,
} from '@farol-ds/react'
import { BenefitIconTypeEnum } from '@jusbrasil-web/shared-apollo-client/types'
import classNames from 'classnames'

import { BenefitsList_OfferLockCardFragment } from './__generated__/benefits-list.graphql'
import styles from './benefits-list.module.scss'

const benefitIconMap: Partial<Record<BenefitIconTypeEnum, IconComponent>> = {
  [BenefitIconTypeEnum.Check]: CheckIcon,
  [BenefitIconTypeEnum.Close]: CloseIcon,
  [BenefitIconTypeEnum.FileSearch]: FileSearchIcon,
  [BenefitIconTypeEnum.Ai]: AiIcon,
  [BenefitIconTypeEnum.Book]: BookIcon,
}

const DEFAULT_ICON = CheckIcon

export type BenefitsListProps = {
  offerLockCard: BenefitsList_OfferLockCardFragment
  benefitsListClassName?: string
  benefitsListIconClassName?: string
  highlightFirstBenefit?: boolean
}

export function BenefitsList({
  offerLockCard,
  benefitsListClassName,
  benefitsListIconClassName,
  highlightFirstBenefit,
}: BenefitsListProps) {
  const { benefitsList = [] } = offerLockCard
  const benefitsListClasses = classNames(styles['benefits-list'], benefitsListClassName)

  const benefitsListIconClasses = classNames(
    styles['benefits-list-icon'],
    benefitsListIconClassName
  )

  return (
    <IconList size="md" unstyled className={benefitsListClasses}>
      {benefitsList.map(({ iconType, name }, index) => {
        const Icon = (iconType && benefitIconMap[iconType]) ?? DEFAULT_ICON

        const isFirstBenefit = index === 0
        const isHighlighted = highlightFirstBenefit && isFirstBenefit

        return (
          <IconList.Item
            key={index}
            icon={!isHighlighted && Icon ? <Icon className={benefitsListIconClasses} /> : null}
          >
            {isHighlighted ? (
              <Heading size="sm" asChild>
                <h4 dangerouslySetInnerHTML={{ __html: name }} />
              </Heading>
            ) : (
              <span dangerouslySetInnerHTML={{ __html: name }} />
            )}
          </IconList.Item>
        )
      })}
    </IconList>
  )
}

BenefitsList.fragments = {
  offerLockCard: gql`
    fragment BenefitsList_offerLockCard on OfferLockCard {
      benefitsList {
        iconType
        name
      }
    }
  `,
}
